// USER
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'